export function getMyGroupsGraphApiQuery(searchText: string, token: string) {
  function getUrl() {
    const sanitizedSearchText = searchText.replace(/[\\"]/g, '');
    const params = new URLSearchParams({
      $search: `"displayName:${sanitizedSearchText}"`,
      $count: 'true',
      $select: 'displayName,id',
      $top: '10',
    });

    return `https://graph.microsoft.com/v1.0/me/transitiveMemberOf/microsoft.graph.group?${params.toString()}`;
  }

  function getOptions(): RequestInit {
    return {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
        // Required by OData Graph query, see
        // https://learn.microsoft.com/en-us/graph/api/user-list-memberof?view=graph-rest-1.0&tabs=http#request-headers
        ConsistencyLevel: 'eventual',
      },
    };
  }

  return { url: getUrl(), options: getOptions() };
}
